// This is just for the Loading or Error Selector
export const GET_CUSTOMERS = "GET_CUSTOMERS";

// Use these for Actions
export const GET_CUSTOMERS_REQUEST = "GET_CUSTOMERS_REQUEST";
export const GET_CUSTOMERS_SUCCESS = "GET_CUSTOMERS_SUCCESS";
export const GET_CUSTOMERS_ERROR = "GET_CUSTOMERS_ERROR";
